export const scrollDown = (target) => {
  const timeout = setTimeout(() => {
    const bottom = document.getElementById(target).scrollHeight;
    document.getElementById(target).scrollTo({ top: bottom });
    clearTimeout(timeout);
  }, 500);
};
